import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Send, Receipt } from "lucide-react";
import api, { formatApiError } from "@/lib/api";

const TARGETS = [["rubinova", "RubiNova"], ["expansion", "Expansión Rubí"]];

export default function SyncGastos({ enCurso }) {
  const [info, setInfo] = useState(null);
  const [enviando, setEnviando] = useState(false);

  const cargar = useCallback(async () => {
    try { const { data } = await api.get("/migracion/gastos/sync-estado"); setInfo(data); } catch (e) { toast.error(formatApiError(e)); }
  }, []);
  useEffect(() => { cargar(); }, [cargar]);
  useEffect(() => {
    const pend = Object.values(info?.cola || {}).some((c) => c.pendiente);
    if (!pend) return undefined;
    const t = setTimeout(cargar, 3000);
    return () => clearTimeout(t);
  }, [info, cargar]);

  async function enviar() {
    if (!window.confirm("¿Enviar todos los gastos importados de Defontana a RubiNova y Expansión Rubí? Los que ya se enviaron se omiten.")) return;
    setEnviando(true);
    try {
      const { data } = await api.post("/migracion/gastos/sincronizar");
      toast.success(`${data.encolados} gastos encolados para RubiNova / Expansión Rubí`);
      cargar();
    } catch (e) { toast.error(formatApiError(e)); } finally { setEnviando(false); }
  }

  return (
    <div className="surface-card p-5" data-testid="card-sync-gastos">
      <div className="flex items-start justify-between flex-wrap gap-4">
        <div className="min-w-0">
          <div className="flex items-center gap-2 mb-1"><Receipt className="w-4 h-4 text-brand-amber" /><h3 className="font-display font-bold text-brand-ink">Gastos operativos → RubiNova y Expansión Rubí</h3></div>
          <p className="text-xs text-brand-muted">Envía el histórico de gastos importado de Defontana (facturas de proveedor y pólizas contables) a ambos sistemas por la cola de sincronización con reintentos. Los gastos que se importen después se envían automáticamente.</p>
          <div className="flex flex-wrap gap-4 mt-3 text-xs text-brand-slate">
            <span>Gastos importados: <strong data-testid="sync-gastos-total">{info?.gastos_defontana ?? "—"}</strong></span>
            <span>Con póliza contable: <strong data-testid="sync-gastos-poliza">{info?.con_poliza ?? "—"}</strong></span>
            {TARGETS.map(([k, lab]) => {
              const c = info?.cola?.[k] || {};
              return <span key={k} data-testid={`sync-gastos-${k}`}>{lab}: <strong className="text-emerald-700">{c.enviado || 0} enviados</strong>{c.pendiente ? <> · {c.pendiente} en cola</> : null}{(c.error || c.fallido) ? <span className="text-red-600"> · {(c.error || 0) + (c.fallido || 0)} con error</span> : null}</span>;
            })}
            {info?.ultima_sync && <span>Último envío: {new Date(info.ultima_sync).toLocaleString("es-MX")}</span>}
          </div>
        </div>
        <button data-testid="btn-sync-gastos" disabled={enCurso || enviando} onClick={enviar} className="btn-ink h-10 px-4 text-sm disabled:opacity-50">{enviando ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} Enviar gastos históricos</button>
      </div>
    </div>
  );
}
